import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {buildUserInfoPayload} from './CurrentUserInfoEpic'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_USER_INFO_LOADING,
  ACTION_USER_INFO_LOADED,
  ACTION_USER_INFO_ERROR,
  PATH_USER,
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_USER_INFO_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_USER_INFO_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_USER}/${action.payload.userId}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        const userInfo = data.response

        return {
          type: ACTION_USER_INFO_LOADED, payload: buildUserInfoPayload(userInfo)
        }
      }).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/SelectedUserInfoEpic.js